module.exports = __webpack_public_path__ + "static/media/about_right.050612e4.png";